import Custom from '@/api/custom'
let apiNote = new Custom('bookNotes')
const state = {
    notes: []
}

const actions = {
    async getNotes ({ commit }) {
        let res = await apiNote.getRecords({
            pageIndex: 1,
            pageSize: 999
        })
        let notes = res.rows
        commit('setNotes', notes)
        return res
    }
}
const mutations = {
    setNotes (state, val) {
        state.notes = val
    }
}

export default {
    state,
    actions,
    mutations
}
